import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface LichPhoBien {
  name: string;
  api_token: string;
}

export interface LichPhoBienDetaiInfor {
  errors: unknown;
  LichPhoBien: LichPhoBien;
  isAuthenticated: boolean;
}

@Module
export default class LichPhoBienDetail
  extends VuexModule
  implements LichPhoBienDetaiInfor
{
  errors = {};
  LichPhoBien = {} as LichPhoBien;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get LichPhoBienDetail() {
    return this.lichPhoBienDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.LICH_PHO_BIEN_DETAIL_DATA](LichPhoBien) {
    this.lichPhoBienDetailData = LichPhoBien;
  }
  @Action
  [Actions.LICH_PHO_BIEN_DETAIL](payload) {
    return ApiService.getDataDetail("/lichphobien", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.LICH_PHO_BIEN_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
